<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<p class="CT-VERSO">“Stay away from the windows during a thunderstorm!”</p>
</div>
<p class="COT">Ah, the eternal struggle: kids who want to watch a showy lightning storm vs. the parents who want them away from the window! The National Weather Service has your back, moms and dads: they list <a id="page_6">windows as something to avoid during a storm, in a long list that also includes other parental bugaboos like showers, sinks, light switches, and corded telephones (remember those?).</a></p><a id="page_6">
<p class="TX">Closing the window helps, but mostly because it lowers your risk of being hit by debris—wind knocks down plenty of branches and poles during bad storms, and shards of bark and wood can fly fifty feet or more when lightning strikes a tree. Lightning can still pass through a closed window—glass is a pretty good insulator, but so is air, and lightning obviously has no problem leaping through that. But windows and doors often have metal frames and handles, which can have electrifying results for people caught opening or closing them at the wrong times.</p>
<p class="TX">And yet I cannot, in good conscience, top out the truth meter below at 100 percent. There are about three hundred lightning-related injuries in the U.S. every year, meaning that your odds of being hurt by lightning this year are literally one in a million. Being a window-looker-outer instead of an inner-wall-hugger during a storm will budge those odds, but only slightly. (Every few years, a lightning-strike-through-closed-window makes the news, and no doubt a few more go unreported, but it’s exceedingly rare.) There are also costs to <span class="txit">never</span> getting to watch a dramatic lightning storm pass by, poetry-of-the-soul costs not easily measured by actuaries or the National Weather Service.</p>
<p class="image"><img alt="Images" height="16" src="images/f0005-01.jpg" width="120"/></p>
<p class="TF">TRUE.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?b48e6ca8